/** @typedef {import('@utahdts/utah-design-system').MenuTypes} MenuTypes */

/** @enum {MenuTypes} */
export const menuTypes = {
  VERTICAL: /** @type {MenuTypes} */ ('vertical'),
  HORIZONTAL: /** @type {MenuTypes} */ ('horizontal'),
};
